module.exports = __webpack_public_path__ + "img/Cambodia.99c9e3a3.gif";